export class User {
  id = "";
  username = "";
  firstname = "";
  lastname = "";
  email = "";
  registerDate = "";
  updateDate = "";
}
